var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mapContainer"}},[_c('div',{ref:"map",attrs:{"id":"map"}}),_c('div',{attrs:{"id":"marker"}}),_vm._l((_vm.pois),function(item,i){return _c('div',{key:i,ref:'marker'+ i,refInFor:true})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }